// Docs: IMPLEMENTATION.md §3.4 (navigation components).
// Single source of truth for both shells' navigation.
//
// The app renders one of two shells around the same routes (see App.jsx):
//   - Coach (<768px): 3 tabs + the raised center ▶ button (CoachTabBar)
//   - Studio (≥768px): left sidebar rail (StudioRail)
// `icon` names resolve via components/NavIcons.jsx.

// Coach shell — mobile bottom bar. The center ▶ action sits between
// `heute` and `bibliothek` and is rendered by CoachTabBar itself.
// `sections` lists every route prefix that lives "under" a tab, so the tab
// stays highlighted on its sub-pages (Nachschlagen, Pool-Scout, Statistik…)
// instead of leaving the bar with nothing selected.
export const coachTabs = [
  { path: '/', label: 'heute', icon: 'heute' },
  { path: '/words', label: 'bibliothek', icon: 'woerter', sections: ['/words', '/discover'] },
  { path: '/profile', label: 'profil', icon: 'profil', sections: ['/profile', '/stats', '/settings'] },
];

// Routes the Coach centre button (▶) owns — the lesson runner (both bars are
// hidden while it runs, but the active state stays right if they show).
export const coachCenterSections = ['/practice'];

// Studio shell — desktop rail (profile lives in the rail footer).
export const studioRail = [
  { path: '/', label: 'heute', icon: 'heute' },
  { path: '/words', label: 'wörter', icon: 'woerter' },
  { path: '/discover', label: 'entdecken', icon: 'entdecken' },
  { path: '/stats', label: 'statistik', icon: 'statistik' },
];

// Every top-level destination, used by the command palette's navigate
// commands (both shells' bars show only a subset).
export const navItems = [
  { path: '/', label: 'heute', icon: 'heute' },
  { path: '/words', label: 'wörter', icon: 'woerter' },
  { path: '/discover', label: 'entdecken', icon: 'entdecken' },
  { path: '/stats', label: 'statistik', icon: 'statistik' },
  { path: '/settings', label: 'einstellungen', icon: 'einstellungen' },
];

// Studio rail footer (profile) also owns the settings pages it links to.
export const studioProfileSections = ['/profile', '/settings'];

// True when `pathname` is `section` itself or one of its sub-routes.
// '/' only matches Home exactly (plus its '/home' alias).
export function isInSection(pathname, section) {
  if (section === '/') return pathname === '/' || pathname === '/home';
  return pathname === section || pathname.startsWith(`${section}/`);
}

export function isNavItemActive(item, pathname) {
  return (item.sections || [item.path]).some((section) => isInSection(pathname, section));
}
